var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckCircleGreenWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 2.66669C8.6413 2.66669 2.66797 8.64002 2.66797 16C2.66797 23.36 8.6413 29.3334 16.0013 29.3334C23.3613 29.3334 29.3346 23.36 29.3346 16C29.3346 8.64002 23.3613 2.66669 16.0013 2.66669Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3353 18.8933L21.1753 11.0533C21.6953 10.5333 22.5486 10.5333 23.0686 11.0533C23.5886 11.5733 23.5886 12.4133 23.0686 12.9333L14.2819 21.72C13.7619 22.24 12.9219 22.24 12.4019 21.72L8.94859 18.2667C8.42859 17.7467 8.42859 16.9067 8.94859 16.3867C9.46859 15.8667 10.3086 15.8667 10.8286 16.3867L13.3353 18.8933Z",
    fill: "#0F8F4D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircleGreenWhite);
export default __webpack_public_path__ + "static/media/icon-check-circle-green-white.10aac374dc4bfbff1eedce6a0e227eff.svg";
export { ForwardRef as ReactComponent };